module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-002"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("THANKSGIVING"), _c('br')]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1%20Corinthians+1:4-9&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("1 CORINTHIANS 1:4-9")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW: ")])]), _vm._v("Paul puts himself in the position of a father; he gives thanks for his children, the Corinthians, all the time, regardless of what they have done. They are called to be one with all believers in Christ (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). Paul begins with praise in order to prepare the Corinthians (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v(") for the admonition that is to come (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR")]), _vm._v("). Some of the Corinthians were no longer living according to their faith, so as to appear to make void the grace they had once received (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER, ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS")]), _vm._v("). On the day of the Lord (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME),")]), _vm._v(" unbelievers will know the truth of what they disbelieved. Christians will find that what they believed is wonderful beyond what they had imagined (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-032"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:4a "), _c('i', [_vm._v("Thanking God for Them")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL THE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IME.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Paul does not just give thanks for the Corinthians some of the time, nor only when they do good. He puts himself in the position of a father, who is thankful for his children all the time, whatever they may have done. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON 1 ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.2.1-15.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN20",
      "id": "ap_NFIN20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-033"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:4b "), _c('i', [_vm._v("The Grace of God Given in Christ Jesus")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LONE.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("God has decreed that a person who believes in Christ can be saved without works. By faith alone he receives the forgiveness of his sins. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN21",
      "id": "ap_NFIN21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT BY ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("You were saved by grace, not by works. And who gave you this grace? It was not Paul, or another apostle, but Jesus Christ himself. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 2.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN22",
      "id": "ap_NFIN22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WEET ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGINNING.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("Paul takes care to sweeten their ears before starting to admonish them. What he says is true, however: He gives thanks to God because of the gifts which have been given to them. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 166.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN23",
      "id": "ap_NFIN23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-034"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:5 "), _c('i', [_vm._v("Enriched with Speech and Knowledge")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PEECH ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OES ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URTHER.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Knowledge shows what there is to know. Speech goes further and explains it. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON 1 ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.2.29-30.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN24",
      "id": "ap_NFIN24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEADFAST IN ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE TO ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CQUIRE ")]), _vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOWLEDGE.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("This means that the Corinthians have remained steadfast in the grace which they have received and in the preaching of the doctrine of truth, because they have acquired "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("spiritual knowledge. Paul therefore gives thanks to God for these things. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN25",
      "id": "ap_NFIN25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCE ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESSED WITH ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACE.")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("When the Corinthians came to faith in Christ they were blessed with all grace. But now that they were no longer living according to their faith, they had made void the grace which they had received. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN26",
      "id": "ap_NFIN26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDERSTAND AND TO ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PEAK.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("There is knowledge which goes beyond speech. Many have knowledge which they cannot express—for example, those who are uneducated and unable to express themselves clearly. But the Corinthians were not like them. They were able both to understand and to speak. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 2.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN27",
      "id": "ap_NFIN27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-035"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:6 "), _c('i', [_vm._v("The Testimony to Christ")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFIRMED IN ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("The testimony of Christ is confirmed in us if we can say, like the apostle Paul, “I am persuaded that neither life nor death etc. can separate us from the love of God in Christ Jesus our Lord” [Rom 8:38-39]. But if we are upset by every little thing that happens, then Christ’s testimony has not been confirmed in us at all. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON 1 ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.2.35-40.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN28",
      "id": "ap_NFIN28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTIMONY ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRENGTHENED BY ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("The testimony of Christ has been confirmed in them because they have been strengthened by their faith. They had come to put no trust in human things. Rather, all their hope was in Christ, for they were ensnared neither by pleasure nor by the enticements of pleasure. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN29",
      "id": "ap_NFIN29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-036"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:7a "), _c('i', [_vm._v("Lacking No Spiritual Gift")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITICISM.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("These praises are not uncritical, as the rest of the epistle makes clear. But they are inserted in order to prepare the Corinthians for the criticism which is to come. For whoever starts out with unpleasant words antagonizes his hearers. Paul starts by praising them in order to avoid this. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 2.5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN30",
      "id": "ap_NFIN30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIMPEACHABLE IN THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESENT.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME: ")]), _vm._v("Although we lack no gift, nevertheless we await the appearance of our Lord Jesus Christ. He will then keep us secure in all things and present us unimpeachable when the day of our Lord Jesus Christ comes. The end of the world shall arrive, when no flesh may glory in his sight. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST THE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIANS 2.8.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN31",
      "id": "ap_NFIN31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-037"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:7b "), _c('i', [_vm._v("The Revealing of Our Lord Jesus Christ")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITING FOR THE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVEALING.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("In this life the righteous person does not yet enjoy what he hopes for but rather endures suffering and danger. He is waiting for the revelation of Christ to come. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON 1 ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.2.48-51.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN32",
      "id": "ap_NFIN32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELIEVERS AND ")]), _vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NBELIEVERS ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WAIT ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("It is clear that Paul was a circumspect man who was full of concern as he awaited the day of judgment. On that day the Lord Jesus Christ will be revealed both to believers and to unbelievers. Then unbelievers will realize that what they did not want to believe is in fact true. Believers will rejoice, finding that what they believed in is more wonderful than they had imagined. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES")]), _c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v(".")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN33",
      "id": "ap_NFIN33-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVELATION ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW ")]), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDDEN.")])]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAGIUS: ")]), _vm._v("Christ’s second coming is described as a revelation, because now it is hidden from us. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN34",
      "id": "ap_NFIN34-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-038"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:8 "), _c('i', [_vm._v("Sustained by Christ")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USTAINED ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREVER.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Who sustains us? Christ Jesus, the Word and Wisdom of God. Moreover, he sustains us not merely for a day or two, but forever. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMEN"), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("TARY ON 1 ")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.2.52-54.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN35",
      "id": "ap_NFIN35-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILTLESS IN THE ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY OF ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR ")]), _vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Paul is confident that the Corinthians will persevere in righteousness until the day of judgment. People who could not be shaken in spite of so many turmoils and disagreements proved that they would remain faithful to the end. In praising them, Paul is also challenging those who had been corrupted by the errors of the false apostles, for in proclaiming the faith of the former, he is calling the latter to repentance. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN36",
      "id": "ap_NFIN36-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDDEN ")]), _vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPROOF.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("This is not praise but backhanded reproof, since the Corinthians were far from “guiltless,” as the rest of the epistle makes clear. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 2.7.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN37",
      "id": "ap_NFIN37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILTY, ")]), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UILTLESS.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORET OF ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YR: ")]), _vm._v("By saying that he hopes that they will be guiltless in the day of Christ Jesus, Paul is indicating that right now they are guilty. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 167.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN38",
      "id": "ap_NFIN38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-039"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:9a "), _c('i', [_vm._v("God Is Faithful")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITHFUL.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENT OF ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA: ")]), _vm._v("That God is faithful means that we can trust his self-revelation. His Word reveals him. He is the God who is faithful. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TROMATEIS 2.27.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN39",
      "id": "ap_NFIN39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROBLEM ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ")]), _vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT WITH ")]), _vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM: ")]), _vm._v("Paul says this so that the Corinthians will not fall into despair when he criticizes them. He reminds them that God is not the problem. We are, because of our sin and unbelief. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES OF ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL TO THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 2.7.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN40",
      "id": "ap_NFIN40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-040"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("1:9b "), _c('i', [_vm._v("Called into Fellowship by God")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLED TO ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE WITH ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN: ")]), _vm._v("Believe in Christ always, because you were called for no other purpose than to be one with us in him. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON 1 ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORINTHIANS 1.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN41",
      "id": "ap_NFIN41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITHFUL TO ")]), _vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR ")]), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DOPTION.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSIASTER: ")]), _vm._v("Fellowship is brotherhood. Just as Paul declares "), _c('i', [_vm._v("God’s")]), _vm._v(" unfailing faithfulness toward us in this regard, so "), _c('i', [_vm._v("we ourselves")]), _vm._v(" must not be found to be faithless or dishonorable with respect to our adoption. Rather we must remain faithful in it. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL’S ")]), _vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLES.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen13#NFIN42",
      "id": "ap_NFIN42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098def88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap3.vue
// module id = 87
// module chunks = 0